/* eslint-disable no-unreachable */
/* eslint-disable no-console */
import React, { useContext } from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { MediaContext } from '..';
import { catchErr } from '../../../libs/HelperContent';
import { getFolder, getSharedList } from '../../actions/media_actions';

/* eslint-disable max-len */
const useMediaDriveFun = ({ uploadFilesFunc = () => {} }) =>
{
	const { tab } = useContext(MediaContext);
	const userData = useSelector((state:any) => state.mysession.session);
	const userId = useParams()?.userId || '';
	let downloadSize = 0;

	const getInsideFoldersList = async (fileData) =>
	{
		const foldersList:any = [];

		for (const fileD of fileData)
		{
			if (fileD?.media && Object.keys(fileD?.media)?.length > 0)
			{
				const newFileD:any = { name: fileD?.media?.name, media: fileD?.media, folders: [], parent: fileD?.parent };

				foldersList.push(newFileD);
				downloadSize = downloadSize + fileD?.media?.size;
			}
			else
			{
				const innerFolders = { name: fileD?.name, media: {}, folders: [] };
				let nestedData = [];

				try
				{
					const query:any = {
						uid     : userData?.userId,
						comid   : userData?.companyId,
						empRole : userData?.empRole,
						role    : userData?.role,
						id      : fileD?.folderId
					};

					if (userId) query.userId = userId;

					const res = [ 0, 2 ].includes(tab) ? await getFolder(query, 'folders') : await getSharedList(query);

					if (res?.status)
					{
						nestedData = res?.data;
					}
				}
				catch (err)
				{
					console.log('err****Inside Folder');
					catchErr(err);
				}
				const { nestedFoldersData } = await getInsideFoldersList(nestedData);

				innerFolders.folders = nestedFoldersData;
				foldersList.push(innerFolders);
			}
		}
		const nestedFoldersData:any = foldersList;

		return { nestedFoldersData, downloadSize };
	};

	return { getInsideFoldersList };
};

export default useMediaDriveFun;